import React, { useState, useEffect } from 'react'
import { Form, Row, Accordion, Col } from 'react-bootstrap'
import UslugaCard from '../UslugaCard/UslugaCard';
import UslugaFilter from '../UslugaFilter/UslugaFilter'
import { Modal, Button } from 'react-bootstrap'
import './ServisList.css'

const ServiceList = (props) => {

    const [modal, setModal] = useState({
        show: false,
        shown: false,
    });

    let usluge = (
        props.uslugaGrupaList.map((uslugaGrupa, index) => (
            (props.listToShow === uslugaGrupa.sifraGrupe) &&
            uslugaGrupa.uslugaList.map((usluga, index) => (
                < UslugaCard usluga={usluga} pickedUslugaId={props.pickedUslugaId} handleChange={props.handleChange} index={index} key={usluga.idUsluge} handleDownloadPdf={props.handleDownloadPdf} />
            ))
        ))
    );

    let filter = (
        props.uslugaGrupaList.map((uslugaGrupa) => (
            <UslugaFilter filterList={props.filterList} sifraGrupe={uslugaGrupa.sifraGrupe} nazivGrupe={uslugaGrupa.nazivGrupe} listToShow={props.listToShow} key={uslugaGrupa.sifraGrupe} />
        ))
    );

    useEffect(() => {
        if (props.listToShow === 4 && usluge[3].length === 0 && modal.show === false && modal.shown === false) {
            setModal({
                show: true,
                shown: true,
            });
        }
    }, [modal, props.listToShow, usluge]);

    const handleCloseModal = () => {
        window.location.href = '/';
        setModal({
            show: false,
            shown: true
        });
    }

    return (
        <>
            <Form.Group className='grupa'>
                <Row className="filter-group" style={{ paddingLeft: "15px", paddingRight: "15px" }}>
                    {filter}
                </Row>
                <Accordion>
                    {
                        props.listToShow !== 0 ? <>
                            <hr />
                        </> : null
                    }
                    <Row style={{ paddingLeft: "15px", paddingRight: "15px" }}>
                        {
                            props.listToShow !== 0 ? <>
                                <h5 className='d-sm-none'>Odaberite uslugu</h5>
                            </> : null
                        }
                        {usluge}
                    </Row>
                </Accordion>

                {props.validated === true && props.uslugePicked === false ? <Row><Col><div className="usluge-invalid" role="alert">Potrebno je odabrati uslugu za predaju dokumentacije.</div></Col></Row> : null}

            </Form.Group>
            <Modal show={modal.show} onHide={handleCloseModal} centered role="alertdialog">
                <Modal.Header closeButton>
                    Obavijest
                </Modal.Header>
                <Modal.Body role="alert">
                    Poštovani, zbog prilagodbe sustava provedbe ovrhe na novčanim sredstvima za potrebe uvođenja eura, nije moguće korištenje ovog sustava do ponedjeljka 2.1.2023. godine.
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleCloseModal} >
                        Zatvori
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default ServiceList
